import React from 'react'
import cn from 'classnames'
import styles from './translation-display.module.scss'

export default function TranslationDisplay({ answer, loading, onClose, targetLanguage = 'en' }) {
    const translatedText = answer?.content_translated?.[targetLanguage]

    if (!loading && !translatedText) {
        return null
    }

    return (
        <div className={styles.translationContainer}>
            <div className={styles.translationHeader}>
                <div className={styles.translationTitle}>
                    <i className="fa fa-language" />
                    <span>Translated ({targetLanguage}):</span>
                </div>
                <button onClick={onClose} className={styles.closeButton}>
                    <i className="fa fa-times" />
                </button>
            </div>
            <div className={styles.translationContent}>
                {loading && !translatedText ? (
                    <span>
                        <i className="fa fa-spinner fa-spin" /> Translating...
                    </span>
                ) : (
                    translatedText
                )}
            </div>
        </div>
    )
}
